import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Hint } from "@progress/kendo-react-labels";

const CommonInput = ({
  id,
  value = "",
  onChange,
  required = false,
  maxLength,
  readOnly = false,
  placeholder = "",
  ...rest
}) => {
  return (
    <div>
      <Input
        name={id}
        id={id}
        style={{ width: "100%" }}
        onChange={onChange}
        value={value}
        required={required}
        maxLength={maxLength}
        readOnly={readOnly}
        placeholder={placeholder}
        {...rest}
      />
      {maxLength && (
        <Hint direction={"end"}>
          {value.length} / {maxLength}
        </Hint>
      )}
    </div>
  );
};

export default CommonInput;
